<template>
    <div class="container">
        <div class="page-content mt-10">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        {{ $t('settings.title') }}
                    </h1>
                </div>

                <div class="col-12 settings-form">
                    <div class="">
                        <label for="avatar" class="mb-1">{{ $t('settings.chooseAvatar') }}</label>
                        <div class="avatar-carousel mb-4">
                            <template v-for="avatar in avatars">
                                <div :class="'avatar-image '+(avatar.id === $store.state.user.avatar?.id ? 'selected' : '')"
                                     :style="'background-image: url(/assets/dipocaco/avatars/'+avatar.filename+')'"
                                     v-on:click="updateAvatar(avatar)">

                                </div>
                            </template>
                        </div>
                    </div>

<!--                    <div class="form-check form-switch">-->
<!--                        <label for="darkmode" class="form-check-label">Enable Darkmode</label>-->
<!--                        <input id="darkmode" type="checkbox" class="form-check-input" v-model="settings.use_dark_mode">-->
<!--                    </div>-->

                    <div class="form-check form-switch">
                        <label for="unknown" class="form-check-label">{{ $t('settings.showUnknown') }}</label>
                        <input id="unknown" type="checkbox" class="form-check-input" v-model="settings.show_unowned">
                    </div>

                    <div class="form-check form-switch">
                        <label for="disable-seasonal" class="form-check-label">{{ $t('settings.disableSeasonalDesigns') }}</label>
                        <input id="disable-seasonal" type="checkbox" class="form-check-input" v-model="settings.disable_seasonal_designs">
                    </div>

                    <div class="form-group">
                        <label for="language" class="label">{{ $t('settings.language') }}</label>
                        <select id="language" class="form-control" v-model="settings.language">
                            <option value="en">{{ $t('settings.languages.en') }}</option>
                            <option value="de">{{ $t('settings.languages.de') }}</option>
                        </select>
                    </div>

                    <div class="form-group mt-3" v-on:click="askForPermission">
                        <button class="btn btn-success w-100">
                            {{ $t('settings.enablePush') }}
                        </button>
                    </div>

                    <div class="form-group mt-3">
                        <a class="btn btn-danger w-100" href="/logout">{{ $t('settings.logout') }}</a>
                    </div>

                    <div class="form-group mt-3">
                        <button class="btn btn-danger w-100" disabled>
                            {{ $t('settings.deleteAccount') }}<br>
                            <small class="muted m-0" style="font-size: 0.5em">To be implemented</small>
                        </button>
                    </div>

<!--                    <hr>-->

<!--                    <div class="form-group">-->
<!--                        <label for="bug">Submit feedback or issues</label>-->
<!--                        <textarea name="bug" id="bug" cols="30" rows="10" class="form-control" v-model="bugSubmit"></textarea>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Inventory",
    data() {
        return {
            settings: {
                use_dark_mode: true,
                show_unowned: true,
                disable_seasonal_designs: true,
                language: 'en',
            },
            bugSubmit: '',
            avatars: [],
            newlyGranted: false
        };
    },
    mounted() {
        this.$store.commit('updateUserData');

        axios.get('/api/user/avatars').then(response => {
            this.avatars = response.data;
        })
    },
    computed: {
        hasNoNotificationPermissionGranted() {
            return this.newlyGranted === false && Notification.permission !== 'granted';
        }
    },
    watch: {
        settings: {
            handler: function (newVal, oldVal) {
                this.$store.commit('updateSettings', {
                    settings: newVal,
                    callback: () => {
                        this.$store.commit('applyTheme');
                        this.$store.commit('updateUserData');
                        this.$forceUpdate();
                    }
                });
            },
            deep: true,
        }
    },
    methods: {
        updateAvatar(avatar) {
            axios.post('/api/user/avatars', {
                avatar_id: avatar.id
            }).then(response => {
                this.$store.commit('updateUserData');
                this.avatars = response.data;

                iziToast.success({
                    title: this.$i18n.t('settings.updateAvatar'),
                    position: 'topCenter',
                })
            })
        },
        askForPermission() {
            Notification.requestPermission().then(answer => {
                if (answer === 'granted') {
                    this.newlyGranted = true;
                    navigator.serviceWorker.ready.then((serviceWorker) => {
                        serviceWorker.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: 'BA33Bd4BHuuRHVEgKc7Mgy8vLUugFMc8ou6SUqlm8LlnpiCAFwGthOUg1Poy46meZMOH8xs4Q3KVymsJ4MTcbtM'
                        }).then(subscription => {
                            fetch('/api/push-subscribe', {
                                method: 'POST',
                                body: JSON.stringify(subscription),
                            }).then((response) => {
                                iziToast.success({
                                    title: this.$i18n.t('settings.pushEnabled'),
                                });
                            })
                        })
                    })
                }
            });
        }
    },
};
</script>


<style scoped lang="scss">
.page-heading {
    background-image: url("/assets/dipocaco/pocas/settings-poca.jpg");
    background-position: center 45%;
}

.settings-form {
    font-size: 1.5em;

    input {
        border-radius: 25px;
    }

    .form-check {
        margin-bottom: 1em;
    }
}

.avatar-carousel {
    max-width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    height: 4.5em;

    .avatar-image {
        height: 4em;
        width: 4em;
        background-size: contain;
        background-repeat: no-repeat;
        display: inline-block;

        &:not(:last-child) {
            margin-right: 0.5em;
        }

        &.selected {
            background-color: lightgreen;
            border-radius: 15px;
        }
    }
}
</style>
